<template>
  <b-modal
      id="tableValuesBeneficiary"
      modal-class="modal-dark"
      :title="`Tabela de valores - ${textModal}`"
      hide-footer
      @hide="handleClose"
      size="xl"
  >
    <b-card-text>
      <b-row>
        <b-col class="col-md-12">
          <b-skeleton-table
              :rows="5"
              :columns="6"
              :table-props="{ bordered: true, striped: true }"
              v-if="loading"
          ></b-skeleton-table>
          <b-table
              ref="tblBeneficiaries"
              responsive
              :fields="tableColumns"
              :items="data"
              primary-key="id"
              show-empty
              empty-text="Nenhum registro encontrado"
              class="position-relative tblBeneficiaryResume"
              v-else
          >
            <template #cell(faixa_atual)="data">
              <span class="ml-1" v-if="data.item.faixa_atual !== null">
                <b-badge variant='success'>
                  {{ data.item.faixa_atual }}
                </b-badge>
              </span>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-card-text>
  </b-modal>
</template>

<script>

import BeneficiaryService from "@/services/BeneficiaryService";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

export default {
  name: "TableValuesBeneficiary",
  props:{
    id:{
      type: Number,
      required: true,
    },
  },
  mounted() {
    this.$bvModal.show('tableValuesBeneficiary');

    this.loading = true;
    BeneficiaryService.getTabelValuesByBeneficiaryId(this.id).then(resp => {
      this.data = resp.data.map(item => {
        this.textModal = item.nome_completo;
        return {
          beneficiario: item.nome_completo,
          faixa_etaria_inicial: item.faixa_etaria_inicial,
          faixa_etaria_final: item.faixa_etaria_final,
          taxa_administrativa: parseFloat(item.taxa_administrativa)
              .toLocaleString('pt-BR', { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' }),
          valor: parseFloat(item.valor)
              .toLocaleString('pt-BR', { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' }),
          faixa_atual: item.faixa_atual
        }
      });

      this.loading = false;
    }).catch(err => {
      this.loading = false;
      this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Oops!',
              icon: 'BellIcon',
              text: 'Ocorreu um erro ao buscar a tabela de valores do beneficiário.',
              variant: 'danger',
            },
          },
          {
            position: 'top-center'
          })
    })
  },
  data() {
    return {
      loading: false,
      tableColumns: [
        { key: 'beneficiario', sortable: false },
        { key: 'faixa_etaria_inicial', sortable: false },
        { key: 'faixa_etaria_final', sortable: false },
        { key: 'taxa_administrativa', sortable: false },
        { key: 'valor', sortable: false },
        { key: 'faixa_atual', sortable: false },
      ],
      data: [],
      textModal: null,
    }
  },
  methods:{
    handleClose(modalClosed = false) {
      this.$emit('closedModal', {modalClosed: modalClosed})
    }
  }
}
</script>

<style scoped>

</style>